import {
  productFunction,
  addCompare,
  deleteCompare,
  productDetail,
  productINCI,
  brand,
  brandMarket,
  INCI,
  formulation
} from '@/axios/api/compare'
import { Message } from 'element-ui'

const UPDATE_STATE = 'UPDATE_STATE'
const UPDATE_IS_SHOW = 'UPDATE_IS_SHOW'
const UPDATE_COUNT = 'UPDATE_COUNT'
const UPDATE_TYPE = 'UPDATE_TYPE'

const state = {
  productFunction: [], //product > function 下拉
  loading:{
    brandList: false,
    brandMarket: false,
    productDetail: false,
    productINCI: false,
    formulation: false,
    INCI: false
  },
  type: '',
  isShow: false,
  brand: 0, // 品牌对比计数
  formulation: 0, // 配方对比计数
  goods: 0, // goods对比计数
  inci: 0, // inci对比计数
  brandList: [],
  brandMarket: [],
  INCIList: [],
  INCIFunction: {},
  INCIFunctionClaims: [],
  INCIPicture: {},
  productList: [],
  productINCI: [],
  formulationList: [],
  formulationProductList: []
}

const getters = {
  loading: state => state.loading,
  type: state => state.type,
  isShow: state => state.isShow,
  // 对比技术
  brand: state => state.brand,
  formulation: state => state.formulation,
  goods: state => state.goods,
  inci: state => state.inci,
  length: state => state.length,
  // 对比列表
  brandList: state => state.brandList,
  brandMarket: state => state.brandMarket,
  INCIList: state => state.INCIList,
  INCIFunction: state => state.INCIFunction,
  INCIFunctionClaims: state => state.INCIFunctionClaims,
  INCIPicture: state => state.INCIPicture,
  productList: state => state.productList,
  productINCI: state => state.productINCI,
  formulationList: state => state.formulationList,
  formulationProductList: state => state.formulationProductList,
  // product > functions
  productFunction: state => state.productFunction
}

const mutations = {
  [UPDATE_STATE] (state, {key, value, subKey}) {
    subKey
      ? state[key][subKey] = value
      : state[key] = value
  },
  [UPDATE_TYPE] (state, type) {
    state.type = type
  },
  [UPDATE_COUNT] (state, { moduleType, count }) {
    state[moduleType] = count
  },
  [UPDATE_IS_SHOW] (state, isShow) {
    state.isShow = isShow
  }
}

const actions = {
  async productFunctionApi ({ commit }) {
    try {
      const { data } = await productFunction()
      commit(UPDATE_STATE, {key: 'productFunction', value: data})
    } catch (e) {}
  },
  // moduleType: brand | formulation | goods | inci
  async addCompareApi ({ commit }, { moduleType, entityId, mark }) {
    try {
      const { data: count } = await addCompare({ moduleType, entityId, mark })
      commit(UPDATE_TYPE, moduleType)
      commit(UPDATE_IS_SHOW, true)
      commit(UPDATE_COUNT, { moduleType, count })
      Message.success(window.$lang('message.addSuccess'))
    } catch (e) {
      console.log(e)
      return e
    }
  },
  async deleteCompareApi ({ commit, dispatch }, { moduleType, entityId, mark }) {
    try {
      const { data: count } = await deleteCompare({ moduleType, entityId, mark, hidden: 1})
      commit(UPDATE_COUNT, { moduleType, count })
      Message.success(window.$lang('message.deleteSuccess'))
      switch(moduleType){
        case 'goods': dispatch('productApi')
              break;
        case 'brand': dispatch('brandApi')
              break;
        case 'formulation': dispatch('formulationApi')
              break;
        case 'inci': dispatch('INCIListApi')
          break
      }
      commit(UPDATE_TYPE, moduleType)
      return !!count
    } catch (e) {}
  },
  async brandApi ({ commit }, payload) {
    commit(UPDATE_STATE, {key: 'loading', subKey: 'brandList', value: true})
    try {
      const { data } = await brand(payload)
      commit(UPDATE_STATE, {key: 'brandList', value: data || []})
      return true
    } catch (e) {
      commit(UPDATE_STATE, {key: 'brandList', value: []})
    } finally {
      commit(UPDATE_STATE, {key: 'loading', subKey: 'brandList', value: false})
    }
  },
  async brandMarketApi ({ commit }, payload) {
    commit(UPDATE_STATE, {key: 'loading', subKey: 'brandMarket', value: true})
    try {
      const { data } = await brandMarket(payload)
      commit(UPDATE_STATE, {key: 'brandMarket', value: data || []})
    } catch (e) {
      commit(UPDATE_STATE, {key: 'brandMarket', value: []})
    } finally {
      commit(UPDATE_STATE, {key: 'loading', subKey: 'brandMarket', value: false})
    }
  },
  async productApi ({ commit }, payload) {
    commit(UPDATE_STATE, {key: 'loading', subKey: 'productDetail', value: true})
    try {
      const { data } = await productDetail(payload)
      commit(UPDATE_STATE, {key: 'productList', value: data || []})
    } catch (e) {
      commit(UPDATE_STATE, {key: 'productList', value: []})
    } finally {
      commit(UPDATE_STATE, {key: 'loading', subKey: 'productDetail', value: false})
    }
  },
  async productINCIApi ({ commit }, payload) {
    commit(UPDATE_STATE, {key: 'loading', subKey: 'productINCI', value: true})
    try {
      const { data } = await productINCI(payload)
      commit(UPDATE_STATE, {key: 'productINCI', value: data || []})
    } catch (e) {
      commit(UPDATE_STATE, {key: 'productINCI', value: []})
    } finally {
      commit(UPDATE_STATE, {key: 'loading', subKey: 'productINCI', value: false})
    }
  },
  async formulationApi ({ commit }, payload) {
    commit(UPDATE_STATE, {key: 'loading', subKey: 'formulation', value: true})
    try {
      const { data: {formulationList, productList} } = await formulation(payload)
      commit(UPDATE_STATE, {key: 'formulationList', value: formulationList || []})
      commit(UPDATE_STATE, {key: 'formulationProductList', value: productList || []})
    } catch (e) {
      commit(UPDATE_STATE, {key: 'formulationList', value: []})
      commit(UPDATE_STATE, {key: 'formulationProductList', value: []})
    } finally {
      commit(UPDATE_STATE, {key: 'loading', subKey: 'formulation', value: false})
    }
  },
  async INCIListApi ({ commit }, payload) {
    commit(UPDATE_STATE, {key: 'loading', subKey: 'INCI', value: true})
    try {
      const { data: {functionMap, inciCounts, inciCompositions, functionClaimMap} } = await INCI(payload)
      commit(UPDATE_STATE, {key: 'INCIPicture', value: inciCounts || {}})
      commit(UPDATE_STATE, {key: 'INCIFunction', value: functionMap || {}})
      commit(UPDATE_STATE, {key: 'INCIFunctionClaims', value: functionClaimMap || {}})
      commit(UPDATE_STATE, {key: 'INCIList', value: inciCompositions || []})
    } catch (e) {
      commit(UPDATE_STATE, {key: 'INCIPicture', value: {}})
      commit(UPDATE_STATE, {key: 'INCIFunction', value: {}})
      commit(UPDATE_STATE, {key: 'INCIList', value: []})
    } finally {
      commit(UPDATE_STATE, {key: 'loading', subKey: 'INCI', value: false})
    }
  },
  setCountShow ({ commit }, params) {
    commit(UPDATE_IS_SHOW, params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/compare.js